import { ConversationResp } from '@marketplace-web/messaging/conversation-messaging-data'

import { api } from './api'

export const confirmComplaintResolved = (conversationId: number | string) =>
  api.patch<ConversationResp>(`/conversations/${conversationId}/complaint/confirm_resolved`)
